import DashboardsNav from '../dashboards/dashboards-nav'
import StrategyMapsGardener from './strategy-maps-gardener'

var StrategyMapsNav = DashboardsNav.extend({
	section: 'strategyMaps',
	Gardener: StrategyMapsGardener
})

export default StrategyMapsNav

StrategyMapsNav.__filename__ = 'strategy-maps/strategy-maps-nav.js'
